import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../../globals';
import { OdsServices } from '../../../services';
import { OdsConfigMenuCreateFinishPage } from './ods-config-menu-create-finish/ods-config-menu-create-finish';

/**
 * Generated class for the CartaCreateDishProdSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-ods-config-menu-create',
  templateUrl: 'ods-config-menu-create.html',
})
export class OdsConfigMenuCreatePage {
  section_name: string = '';
  section_name_ca: string = '';
  section_name_en: string = '';
  section_name_it: string = '';
  section_name_fr: string = '';
  section_name_de: string = '';
  selected_collapse: boolean = false;
  update_state: boolean = false;
  index_section: number;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public toastCtrl: ToastController,
    public translate: TranslateService,
    public odsServices: OdsServices,) {
    if (this.navParams.get('update_state')) {
      this.update_state = this.navParams.get('update_state');
    }
    if (this.navParams.get('section') != undefined) {
      this.odsServices.selected_elements = this.navParams.get('section').elements;
      this.section_name = this.navParams.get('section').name;
      this.section_name_ca = this.navParams.get('section').name_ca;
      this.section_name_en = this.navParams.get('section').name_en;
      this.section_name_it = this.navParams.get('section').name_it;
      this.section_name_fr = this.navParams.get('section').name_fr;
      this.section_name_de = this.navParams.get('section').name_de;
    }
    if (this.navParams.get('index') != undefined) {
      this.index_section = this.navParams.get('index');
    }
  }

  onMainLangChange(value: string) {
    // Detectar el idioma principal
    let mainLang = this.globals.restaurant.lang;
    
    // Si el valor está vacío, no hacer nada
    if (!value || value.trim() === '') {
      return;
    }

    // Copiar el valor a todos los campos de idioma que estén vacíos
    if (mainLang === 'es') {
      if (!this.section_name_ca || this.section_name_ca.trim() === '') this.section_name_ca = value;
      if (!this.section_name_en || this.section_name_en.trim() === '') this.section_name_en = value;
      if (!this.section_name_it || this.section_name_it.trim() === '') this.section_name_it = value;
      if (!this.section_name_fr || this.section_name_fr.trim() === '') this.section_name_fr = value;
      if (!this.section_name_de || this.section_name_de.trim() === '') this.section_name_de = value;
    } else if (mainLang === 'ca') {
      if (!this.section_name || this.section_name.trim() === '') this.section_name = value;
      if (!this.section_name_en || this.section_name_en.trim() === '') this.section_name_en = value;
      if (!this.section_name_it || this.section_name_it.trim() === '') this.section_name_it = value;
      if (!this.section_name_fr || this.section_name_fr.trim() === '') this.section_name_fr = value;
      if (!this.section_name_de || this.section_name_de.trim() === '') this.section_name_de = value;
    } else if (mainLang === 'en') {
      if (!this.section_name || this.section_name.trim() === '') this.section_name = value;
      if (!this.section_name_ca || this.section_name_ca.trim() === '') this.section_name_ca = value;
      if (!this.section_name_it || this.section_name_it.trim() === '') this.section_name_it = value;
      if (!this.section_name_fr || this.section_name_fr.trim() === '') this.section_name_fr = value;
      if (!this.section_name_de || this.section_name_de.trim() === '') this.section_name_de = value;
    } else if (mainLang === 'it') {
      if (!this.section_name || this.section_name.trim() === '') this.section_name = value;
      if (!this.section_name_ca || this.section_name_ca.trim() === '') this.section_name_ca = value;
      if (!this.section_name_en || this.section_name_en.trim() === '') this.section_name_en = value;
      if (!this.section_name_fr || this.section_name_fr.trim() === '') this.section_name_fr = value;
      if (!this.section_name_de || this.section_name_de.trim() === '') this.section_name_de = value;
    } else if (mainLang === 'fr') {
      if (!this.section_name || this.section_name.trim() === '') this.section_name = value;
      if (!this.section_name_ca || this.section_name_ca.trim() === '') this.section_name_ca = value;
      if (!this.section_name_en || this.section_name_en.trim() === '') this.section_name_en = value;
      if (!this.section_name_it || this.section_name_it.trim() === '') this.section_name_it = value;
      if (!this.section_name_de || this.section_name_de.trim() === '') this.section_name_de = value;
    } else if (mainLang === 'de') {
      if (!this.section_name || this.section_name.trim() === '') this.section_name = value;
      if (!this.section_name_ca || this.section_name_ca.trim() === '') this.section_name_ca = value;
      if (!this.section_name_en || this.section_name_en.trim() === '') this.section_name_en = value;
      if (!this.section_name_it || this.section_name_it.trim() === '') this.section_name_it = value;
      if (!this.section_name_fr || this.section_name_fr.trim() === '') this.section_name_fr = value;
    }
  }

  next() {
    if (this.section_name != '' || this.section_name_ca != '' || this.section_name_en != '' || this.section_name_it != '' || this.section_name_fr != '' || this.section_name_de != '') {
      if (this.update_state) {
        this.updateSection();
        this.navCtrl.pop();
      } else {
        this.createSection();
        this.navCtrl.push(OdsConfigMenuCreateFinishPage);
      }
    } else {
      //toast error
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-completa-datos-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  ionViewWillLeave() {
    this.odsServices.selected_elements = [];
  }

  search(value) {
    if (value) {
      this.odsServices.list_elements_filtered = this.odsServices.list_elements.filter(objeto => {
        return this.globals.objectToArray(objeto).some(valor => {
          if (typeof valor === 'string' || typeof valor === 'number') {
            // Comparar como string
            return valor.toString().toLowerCase().includes(value.toLowerCase());
          } else if (Array.isArray(valor)) {
            // Buscar en cada elemento del array
            return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
          }
          return false;
        });
      });
    } else {
      this.odsServices.list_elements_filtered = this.odsServices.list_elements;
    }
  }

  collapse() {
    this.selected_collapse = !this.selected_collapse;
  }

  rellenarIdiomasVacios() {
    // Detectar el idioma principal
    const mainLang = this.globals.restaurant.lang;
    let mainValue = '';
    switch (mainLang) {
      case 'es': mainValue = this.section_name; break;
      case 'ca': mainValue = this.section_name_ca; break;
      case 'en': mainValue = this.section_name_en; break;
      case 'it': mainValue = this.section_name_it; break;
      case 'fr': mainValue = this.section_name_fr; break;
      case 'de': mainValue = this.section_name_de; break;
      default: mainValue = this.section_name;
    }
    if (!this.section_name || this.section_name.trim() === '') this.section_name = mainValue;
    if (!this.section_name_ca || this.section_name_ca.trim() === '') this.section_name_ca = mainValue;
    if (!this.section_name_en || this.section_name_en.trim() === '') this.section_name_en = mainValue;
    if (!this.section_name_it || this.section_name_it.trim() === '') this.section_name_it = mainValue;
    if (!this.section_name_fr || this.section_name_fr.trim() === '') this.section_name_fr = mainValue;
    if (!this.section_name_de || this.section_name_de.trim() === '') this.section_name_de = mainValue;
  }

  updateSection() {
    this.rellenarIdiomasVacios();
    let elements = this.getElementsFormated();
    this.odsServices.carta_takeaway.pages[0].sections[this.index_section].elements = elements;
    this.odsServices.carta_takeaway.pages[0].sections[this.index_section].name = this.section_name;
    this.odsServices.carta_takeaway.pages[0].sections[this.index_section].name_ca = this.section_name_ca;
    this.odsServices.carta_takeaway.pages[0].sections[this.index_section].name_en = this.section_name_en;
    this.odsServices.carta_takeaway.pages[0].sections[this.index_section].name_it = this.section_name_it;
    this.odsServices.carta_takeaway.pages[0].sections[this.index_section].name_fr = this.section_name_fr;
    this.odsServices.carta_takeaway.pages[0].sections[this.index_section].name_de = this.section_name_de;
    const cartaUpdate = { ...this.odsServices.carta_takeaway };
    delete cartaUpdate.UID;
    this.odsServices.firestore.collection('cartas').doc(this.odsServices.carta_takeaway.UID).update(cartaUpdate);
  }

  createSection() {
    this.rellenarIdiomasVacios();
    let elements = this.getElementsFormated();
    //Añadimos los elementos a la seccion
    this.odsServices.carta_takeaway.pages[0].sections = this.globals.objectToArray(this.odsServices.carta_takeaway.pages[0].sections);
    this.odsServices.carta_takeaway.pages[0].sections.push({
      name: this.section_name,
      name_ca: this.section_name_ca,
      name_en: this.section_name_en,
      name_it: this.section_name_it,
      name_fr: this.section_name_fr,
      name_de: this.section_name_de,
      order: this.odsServices.carta_takeaway.pages[0].sections.length + 1,
      elements: elements,
    });
    const cartaUpdate = { ...this.odsServices.carta_takeaway };
    delete cartaUpdate.UID;
    this.odsServices.firestore.collection('cartas').doc(this.odsServices.carta_takeaway.UID).update(cartaUpdate);
  }

  getElementsFormated() {
    let elements = [];
    //Recorremos los elementos seleccionados y preparamos para la seccion
    this.odsServices.selected_elements.forEach((element, index) => {
      elements.push({
        uid: element.UID || element.uid,
        order: index + 1,
        type: element.type,
        name_es: element.name_es || '',
        name_ca: element.name_ca || '',
        name_en: element.name_en || '',
        name_de: element.name_de || '',
        name_fr: element.name_fr || '',
        name_it: element.name_it || '',
        allergens: element.allergens || [],
        price: element.price || element.pvp || 0,
        price_half: element.price_half || element.pvp2 || 0,
        price_tapa: element.price_tapa || element.pvp3 || 0,
        cost_ration: '',
        image: element.image || '',
        description_es: element.description_es || '',
        description_ca: element.description_ca || '',
        description_en: element.description_en || '',
        description_de: element.description_de || '',
        description_fr: element.description_fr || '',
        description_it: element.description_it || '',
        tags: element.tags || [],
        price_takeaway: element.price_takeaway || element.pvp_takeaway || 0,
        tk_active: (element.tk_active === undefined) ? true : element.tk_active,
        featured: (element.featured === undefined) ? true : element.featured,
        tk_pickup_day: element.tk_pickup_day || '',
        tax: element.tax || this.globals.RESTAURANT_TAX,
        variations_favourite: element.variations_favourite || []
      });
    });
    return elements;
  }
}


// WEBPACK FOOTER //
// ./src/pages/ods/ods-config/ods-config-menu/ods-config-menu-create/ods-config-menu-create.ts